import { ChatbotDataLayer } from 'features/chatbot/contexts/ChatbotDataLayer'
import { ChatSession } from 'features/chatbot/contexts/ChatbotSessionContext'
import { ChatbotUXLayer } from 'features/chatbot/contexts/ChatbotUXLayer'
import React from 'react'
import styled from 'styled-components'

import { ChatbotContent } from './ChatbotContent'

const SessionPane = styled.div<{ $isActive: boolean }>`
  display: ${({ $isActive }) => ($isActive ? 'flex' : 'none')};
  flex-direction: column;
  flex: 1;
  min-height: 0;
`

export const SessionPaneContent: React.FC<{
  session: ChatSession
  isActive: boolean
}> = ({ session, isActive }) => {
  return (
    <SessionPane $isActive={isActive}>
      <ChatbotDataLayer session={session}>
        <ChatbotUXLayer>
          <ChatbotContent sessionId={session.id} />
        </ChatbotUXLayer>
      </ChatbotDataLayer>
    </SessionPane>
  )
}
